<template>
  <div class="channel-template" theme>
    <div id="theme-channel-header" />
    <div id="theme-channel-leftside" />
    <div id="theme-channel-content" />
    <div id="theme-channel-rightside" />
    <div id="theme-channel-footer" />
    <b-modal
      id="channel-confirm-modal"
      ref="channelConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="purchase($event)"
    >
      <p class="my-4" v-html="$t('settlement.confirm.settle')" />
    </b-modal>
    <b-modal
      id="delete-review-confirm-modal"
      ref="deleteReviewConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="deleteReview($event)"
    >
      <p class="my-4" v-html="$t('common.modal.text.delete_confirm')" />
    </b-modal>
    <b-modal
      id="update-review-confirm-modal"
      ref="updateReviewConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="updateReview($event)"
    >
      <p class="my-4" v-html="$t('common.modal.text.update_confirm')" />
    </b-modal>
    <b-modal
      id="subscribe-confirm-modal"
      ref="subscribeConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="subscribe($event)"
    >
      <p class="my-4" v-html="$t('channel.confirm.subscribe')" />
    </b-modal>
    <b-modal
      id="unsubscribe-confirm-modal"
      ref="unsubscribeConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="unsubscribe($event)"
    >
      <p class="my-4" v-html="$t('channel.confirm.unsubscribe')" />
    </b-modal>
    <form
      v-if="channel && order && configs.payment_gateway === 'payment_gateway.nicepayments'"
      name="payForm"
      method="post"
      target="_self"
      :action="isMobile?'https://web.nicepay.co.kr/v3/smart/smartPayment.jsp':''"
      :accept-charset="isMobile?'euc-kr':''"
    >
      <input type="hidden" name="GoodsName" :value="channel.nm">
      <input type="hidden" name="PayMethod" :value="getNicepayementsMethod()">
      <input type="hidden" name="GoodsCnt" value="1">
      <input type="hidden" name="Amt" :value="orderInfo.finalAmount">
      <input type="hidden" name="BuyerName" :value="order.buyerNm">
      <input type="hidden" name="BuyerTel" :value="order.buyerTel">
      <input type="hidden" name="Moid" :value="orderInfo.orderNo">
      <input type="hidden" name="MID" :value="orderInfo.mid">

      <input type="hidden" name="UserIP" :value="orderInfo.userIp">
      <input type="hidden" name="MallIP" :value="orderInfo.serverIp">
      <input v-if="isMobile" type="hidden" name="ReturnURL" :value="getApiUrl() + '/nicepayments/public/resultMobile'">
      <input v-if="isMobile" type="hidden" name="MallReserved" :value="mallReserved">
      <input v-if="isMobile" type="hidden" name="AcsNoIframe" value="Y">
      <input type="hidden" name="CharSet" value="utf-8">

      <!-- 옵션 -->
      <input type="hidden" name="VbankExpDate" :value="getExpDate()">
      <input type="hidden" name="BuyerEmail" :value="order.buyerEmail">
      <input type="hidden" name="ChannelCl" value="0">                                  <!-- 상품구분(실물(1),컨텐츠(0)) -->
      <input type="hidden" name="TransType" value="0">                                <!-- 일반(0)/에스크로(1) -->

      <!-- 변경 불가능 -->
      <input type="hidden" name="EncodeParameters" value="CardNo,CardExpire,CardPwd"> <!-- 암호화대상항목 -->
      <input type="hidden" name="EdiDate" :value="orderInfo.ediDate">                 <!-- 전문 생성일시 -->
      <input type="hidden" name="EncryptData" :value="orderInfo.hash">                <!-- 해쉬값	-->
      <input type="hidden" name="TrKey" value="">                                     <!-- 필드만 필요 -->
      <input name="LogoImage" type="hidden" :value="getProtocol() + '//' + getHost() + '/themes/' + configs.theme + '/pack/img/logo-white-square.png'">
    </form>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      order: undefined,
      channel: undefined,
      orderInfo: {},
      isMobile: true,
      mallReserved: '',
      path: 'channel',
      parts: [
        {
          elem: '#theme-channel-header',
          htmlFile: 'header'
        },
        {
          elem: '#theme-channel-leftside',
          htmlFile: 'leftside'
        },
        {
          elem: '#theme-channel-content',
          htmlFile: 'content'
        },
        {
          elem: '#theme-channel-rightside',
          htmlFile: 'rightside'
        },
        {
          elem: '#theme-channel-footer',
          htmlFile: 'footer'
        }
      ]
    }
  },
  mounted() {
    this.isMobile = !!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
      navigator.userAgent
    )
    this.$eventHub.$on('purchase-confirm', this.onPurchaseConfirm)
    this.$eventHub.$on('update-review-confirm', this.onUpdateReviewConfirm)
    this.$eventHub.$on('delete-review-confirm', this.onDeleteReviewConfirm)
    this.$eventHub.$on('channel-content-loaded', this.onChannelContentLoaded)
    this.$eventHub.$on('more-goods', this.onMoreGoodsClicked)
    this.$eventHub.$on(
      'subscribe-channel-confirm',
      this.onSubscribeChannelConfirm
    )
    this.$eventHub.$on(
      'unsubscribe-channel-confirm',
      this.onUnsubscribeChannelConfirm
    )
    window.loadScript('https://web.nicepay.co.kr/v3/webstd/js/nicepay-2.0.js')
  },
  beforeDestroy() {
    this.$eventHub.$off('purchase-confirm', this.onPurchaseConfirm)
    this.$eventHub.$off('update-review-confirm', this.onUpdateReviewConfirm)
    this.$eventHub.$off('delete-review-confirm', this.onDeleteReviewConfirm)
    this.$eventHub.$off('channel-content-loaded', this.onChannelContentLoaded)
    this.$eventHub.$off('more-goods', this.onMoreGoodsClicked)
    this.$eventHub.$off(
      'subscribe-channel-confirm',
      this.onSubscribeChannelConfirm
    )
    this.$eventHub.$off(
      'unsubscribe-channel-confirm',
      this.onUnsubscribeChannelConfirm
    )
  },
  methods: {
    onChannelContentLoaded() {
      this.$nextTick(() => {
        this.loadGoods()
      })
    },
    subscribe() {
      this.$axios
        .$put('channel/subscribe', this.subscribeChannelTarget)
        .then(response => {
          if (response.resultCode === 'success') {
            this.$eventHub.$emit('channel-subscribed', {
              channel: this.subscribeChannelTarget,
              subscribe: response.data,
              componentId: this.componentId
            })
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    },
    unsubscribe() {
      this.$axios
        .$put('channel/unsubscribe', this.unsubscribeChannelTarget)
        .then(response => {
          if (response.resultCode === 'success') {
            this.$eventHub.$emit('channel-unsubscribed', {
              channel: this.unsubscribeChannelTarget,
              componentId: this.componentId
            })
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    },
    onMoreGoodsClicked(params) {
      if (parseInt(params.componentId) === parseInt(this.componentId)) {
        this.loadGoods()
      }
    },
    loadGoods() {
      let url = 'goods/public/goods'
      let menuAlias = this.$router.currentRoute.fullPath
      if (menuAlias.indexOf('?') >= 0) {
        menuAlias = menuAlias.substring(0, menuAlias.indexOf('?'))
      }
      url += '?menu=' + encodeURIComponent(menuAlias)
      url += '&size=12&withContents=true'
      if (this.lastId) {
        url += '&lastId=' + this.lastId
      }

      if (this.$route.query.id) {
        url += '&channelId=' + this.$route.query.id
      } else {
        url += '&channelAlias=' + this.$route.params.alias
      }
      this.$axios.$get(url).then(response => {
        if (response.resultCode === 'success') {
          const goods = response.data.list
          if (goods && goods.length > 0) {
            this.lastId = goods[goods.length - 1].id
          }
          this.$eventHub.$emit('goods-loaded-on-channel', {
            goods: goods,
            loadedSize: response.data.loadedSize,
            totalSize: response.data.totalSize,
            componentId: this.getMainComponentId()
          })
        } else {
          console.error(this.$t(response.message, response.params))
          this.$toast.error(this.$t(response.message, response.params))
        }
      })
    },
    getApiUrl() {
      return process.env.apiUrl
    },
    getCurrentUrl() {
      return window.location.href
    },
    onDeleteReviewConfirm(params) {
      if (parseInt(params.componentId) === parseInt(this.componentId)) {
        this.deleteReviewTarget = params.review
        this.channel = params.item
        this.item = params.item
        this.showModal('deleteReviewConfirmModalRef')
      }
    },
    onSubscribeChannelConfirm(params) {
      if (parseInt(params.componentId) === parseInt(this.componentId)) {
        this.subscribeChannelTarget = params.channel
        this.showModal('subscribeConfirmModalRef')
      }
    },
    onUnsubscribeChannelConfirm(params) {
      if (parseInt(params.componentId) === parseInt(this.componentId)) {
        this.unsubscribeChannelTarget = params.channel
        this.showModal('unsubscribeConfirmModalRef')
      }
    },
    getHost() {
      return window.location.host
    },
    getProtocol() {
      return window.location.protocol
    },
    onUpdateReviewConfirm(params) {
      if (parseInt(params.componentId) === parseInt(this.componentId)) {
        this.updateReviewTarget = params.review
        this.showModal('updateReviewConfirmModalRef')
      }
    },
    deleteReview() {
      this.$axios
        .$delete('review/deleteReview?id=' + this.deleteReviewTarget.id)
        .then(response => {
          if (response.resultCode === 'success') {
            this.$eventHub.$emit('review-deleted', {
              review: this.deleteReviewTarget,
              item: this.channel,
              componentId: this.getMainComponentId(),
              scoreData: response.data.scoreData
            })
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    },
    updateReview: function(e) {
      this.$axios
        .$post('review/updateReview', this.updateReviewTarget)
        .then(response => {
          if (response.resultCode === 'success') {
            this.$eventHub.$emit('review-updated', {
              reviewData: response.data,
              item: this.channel,
              componentId: this.getMainComponentId()
            })
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    },
    onPurchaseConfirm(params) {
      if (parseInt(params.componentId) === parseInt(this.componentId)) {
        this.channel = params.item
        this.item = params.item
        this.order = params.order
        this.nation = params.nation
        this.options = params.options
        this.amount = params.amount
        this.totalAmount = params.totalAmount
        this.point = params.point
        let validated = true
        const self = this

        $(this.$el)
          .find('.show-invalid')
          .each(function() {
            if (!$(this).val()) {
              validated = false
              self.$toast.error($(this).text())
              if ($(this).closest('.input-control').length > 0) {
                $('html').animate(
                  {
                    scrollTop:
                      $(this)
                        .closest('.input-control')
                        .offset().top - 70
                  },
                  400,
                  'swing',
                  () => {
                    $(this)
                      .closest('.input-control')
                      .animate(
                        {
                          opacity: 0.4
                        },
                        200,
                        'swing',
                        () => {
                          $(this)
                            .closest('.input-control')
                            .animate(
                              {
                                opacity: 1
                              },
                              200,
                              'swing'
                            )
                        }
                      )
                  }
                )
              }
            }
            if (!validated) {
              return false
            }
          })
        if (validated) {
          this.showModal('channelConfirmModalRef')
        }
      }
    },
    purchase(e) {
      this.getOrderInfo()
    },
    getExpDate() {
      if (this.order.endde) {
        return this.order.endde.replaceAll('/', '')
      }
      return ''
    },
    getOrderInfo() {
      const param = {
        channel: this.channel,
        options: this.options,
        order: this.order,
        nation: this.nation,
        amount: this.amount,
        totalAmount: this.totalAmount
      }
      if (this.order.setleMthCode === 'settlement_method.point') {
        param.point = this.point
      }
      this.$axios.$post('settlement/getOrderInfo', param).then(response => {
        if (response.resultCode === 'success') {
          this.orderInfo = response.data
          this.order.orderNo = this.orderInfo.orderNo
          this.$forceUpdate()
          this.$nextTick(() => {
            if (this.order.setleMthCode === 'settlement_method.point') {
              this.purchaseComplete()
            } else if (
              this.configs.payment_gateway === 'payment_gateway.nicepayments'
            ) {
              window.nicepaySubmit = this.onCompleteNicepayments
              if (this.isMobile) {
                this.order.tid = $(this.$el)
                  .find('input[name=TID]')
                  .val()
                this.order.virtlAcnutNm = $(this.$el)
                  .find('input[name=VbankAccountName]')
                  .val()

                if (this.order.endde) {
                  this.order.enddeTimestamp = moment(
                    this.order.endde,
                    this.$t('common.format.date')
                  )
                    .toDate()
                    .getTime()
                }
                let params = {
                  channel: {
                    id: this.channel.id,
                    exchangeRate: this.channel.exchangeRate,
                    currency: this.channel.currency
                  },
                  options: this.options,
                  order: this.order,
                  nation: this.nation,
                  amount: this.amount,
                  totalAmount: this.totalAmount,
                  currentUrl: this.getCurrentUrl(),
                  siteId: this.channel.site.id,
                  userId: this.loggedInUser.id
                }
                params = window.copyObject(params)
                this.mallReserved = encodeURIComponent(JSON.stringify(params))
                // document.charset = 'euc-kr'
                this.$nextTick(() => {
                  document.payForm.submit()
                })
              } else {
                window.goPay(document.payForm)
              }
            } else {
              this.purchaseComplete()
            }
          })
        } else {
          console.error(this.$t(response.message, response.params))
          this.$toast.error(this.$t(response.message, response.params))
        }
      })
    },
    onCompleteNicepayments() {
      this.order.tid = $(this.$el)
        .find('input[name=TID]')
        .val()
      this.order.virtlAcnutNm = $(this.$el)
        .find('input[name=VbankAccountName]')
        .val()
      this.order.nicepayParams = {}
      if (this.order.endde) {
        this.order.enddeTimestamp = moment(
          this.order.endde,
          this.$t('common.format.date')
        )
          .toDate()
          .getTime()
      }
      const self = this
      $(this.$el)
        .find('form[name=payForm] input')
        .each(function() {
          self.order.nicepayParams[$(this).attr('name')] = $(this).val()
        })
      if (
        $(this.$el)
          .find('input[name=AuthResultCode]')
          .val() === '0000'
      ) {
        this.purchaseComplete(
          () => {
            $('#nice_layer').fadeOut(400, 'linear', () => {
              $('#nice_layer').remove()
            })
            $('#bg_layer').fadeOut(400, 'linear', () => {
              $('#bg_layer').remove()
            })
          },
          () => {
            $('#nice_layer').fadeOut(400, 'linear', () => {
              $('#nice_layer').remove()
            })
            $('#bg_layer').fadeOut(400, 'linear', () => {
              $('#bg_layer').remove()
            })
          }
        )
      }
    },
    getNicepayementsMethod() {
      if (this.order.setleMthCode === 'settlement_method.creditcard') {
        return 'CARD'
      } else if (
        this.order.setleMthCode === 'settlement_method.account_transfer'
      ) {
        return 'BANK'
      } else if (
        this.order.setleMthCode === 'settlement_method.virtual_account_transfer'
      ) {
        return 'VBANK'
      } else if (this.order.setleMthCode === 'settlement_method.mobile') {
        return 'CELLPHONE'
      }
      return ''
    },
    purchaseComplete(successCb, failCb) {
      const param = {
        channel: this.channel,
        options: this.options,
        order: this.order,
        nation: this.nation,
        amount: this.amount,
        totalAmount: this.totalAmount
      }
      if (this.order.setleMthCode === 'settlement_method.point') {
        param.point = this.point
      }
      this.$axios
        .$post('channel/purchase', param)
        .then(response => {
          if (response.resultCode === 'success') {
            this.$eventHub.$emit('purchase-complete', {
              itemName: 'channel',
              item: response.data.channel,
              componentId: this.getMainComponentId()
            })
            if (successCb) {
              successCb()
            }
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
            if (failCb) {
              failCb()
            }
          }
        })
        .catch(() => {
          if (failCb) {
            failCb()
          }
        })
    }
  }
}
</script>

<style scoped>
.channel-template {
  min-height: 100px;
  margin-top: -35px;
}
</style>
